var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"photo-block"},[_c('div',{staticClass:"photo",style:({background: `url(${_vm.src})`})},[(_vm.action)?_c('div',{staticClass:"actions"},[_c('a-icon',{staticClass:"action-icon",attrs:{"type":"eye"}}),_c('a-icon',{staticClass:"action-icon",attrs:{"type":"delete"}})],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }